import { SearchUser } from "../../../store/slices/GlobalSearchSlice";

export const ROLE_DISPLAY: Record<string, string> = {
    SUPER_ADMIN: "Super Admin",
    ORG_ADMIN: "Organization Admin",
    FINLEY_USER: "Finley User",
    FINANCIAL_COACH: "Coach",
};

export const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const getUserStatus = (user: SearchUser) => {
    if (!user.isActive && user.deactivatedAt) {
        return { label: `Deactivated on ${formatDate(user.deactivatedAt)}`, color: "bg-red-400" };
    }
    if (user.onboardingSate === "ONBOARDING_COMPLETED") {
        return { label: `Active since ${formatDate(user.createdAt)}`, color: "bg-green-500" };
    }
    if (user.onboardingSate === "SIGNED_UP") {
        return { label: `Signed Up on ${formatDate(user.createdAt)}`, color: "bg-yellow-500" };
    }
    if (user.invitationSentAt) {
        return { label: `Invite sent on ${formatDate(user.invitationSentAt)}`, color: "bg-gray-400" };
    }
    return { label: `Active since ${formatDate(user.createdAt)}`, color: "bg-green-500" };
};
